/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Form, Col, FormGroup, Label, Input, Button } from 'reactstrap'

import InputNumber from 'rc-input-number';

import AssociateGateway from './AssociateGateway'

import Select from 'react-select'

import { AppContext } from '../AppContext'

class UserPreferences extends React.Component
{

  authMethodChanged(authMethod)
  {
    this.setState({authMethod: authMethod});
  }

  closeGatewayModal(gatewayName)
  {
    let enabled = ('' === gatewayName ? 'N' : 'Y');
    this.setState({gatewayModalIsOpen: false, gatewayElementsEnabled: enabled});
    this.context.appLocalStorage.setGatewayName(gatewayName);
  }

  componentDidMount()
  {
    this.setState(
    {
      gatewayElementsEnabled: ('' !== this.context.appLocalStorage.getGatewayName() ? 'Y' : 'N'),
      defaultTimezone: { timezone: this.context.userSession.sessionInfo.defaultTimezone },
      autoQueryEnabled: this.context.userUiProfile.autoQueryEnabled,
      autoPlay: this.context.appLocalStorage.getAutoPlay(),
      authMethod: this.context.userSession.sessionInfo.authMethod,
      concurrentFileUploads: this.context.userUiProfile.concurrentFileUploads,
      immutableUponCreation: this.context.userUiProfile.immutableUponCreation,
      rowLimit: this.context.userUiProfile.rowLimit
    });
  }

  concurrentFileUploadsChanged(valueAsNumber, valueAsString, input)
  {
    this.setState(
    {
      concurrentFileUploads: valueAsNumber
    });
  }

  constructor(props)
  {
    super();

    let timezoneArray = [];
    let timezones = window.timezone.tz.names();
    for (let x = 0; x < timezones.length; x++) timezoneArray[x] = {timezone: timezones[x]};

    this.state =
    {
      timezones: timezoneArray,
      defaultTimezone: undefined, 
      autoQueryEnabled: undefined, 
      autoPlay: undefined,
      authMethod: undefined, 
      gatewayElementsEnabled: 'N', 
      concurrentFileUploads: undefined, 
      immutableUponCreation: undefined, 
      gatewayModalIsOpen: false,
      rowLimit: 1,
      updateButtonDisabled: false
    }

    this.updateUserPreferences = this.updateUserPreferences.bind(this);
    this.selectTZone = this.selectTZone.bind(this);
    this.closeGatewayModal = this.closeGatewayModal.bind(this);
    this.toggleGatewayEnabled = this.toggleGatewayEnabled.bind(this);
    this.findDbObscuraGateway = this.findDbObscuraGateway.bind(this);
    this.concurrentFileUploadsChanged = this.concurrentFileUploadsChanged.bind(this);
    this.authMethodChanged = this.authMethodChanged.bind(this);
    this.toggleImmutableOnCreate = this.toggleImmutableOnCreate.bind(this);
    this.toggleAutoPlay = this.toggleAutoPlay.bind(this);
    this.setRowLimit = this.setRowLimit.bind(this);
  }

  async findDbObscuraGateway()
  {
    let bodyData = {};
    bodyData.gatewayName = this.context.appLocalStorage.getGatewayName();
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'findGateway', bodyData);
    if ('success' !== result.status && this.context.dbTwig.GatewayOffline !== result.errorCode)
    {
      this.setState({gatewayElementsEnabled: 'N'});
      return this.context.dbTwig.apiErrorHandler(result, 'Error finding gateway');
    } 

    if ('success' !== result.status && this.context.dbTwig.GatewayOffline === result.errorCode) 
      this.setState({gatewayModalIsOpen: true});
    
    if ('success' === result.status)
    {
      this.context.appLocalStorage.setGatewayName(result.jsonData.gatewayName);
      this.setState({gatewayElementsEnabled: 'Y'});
      this.context.postNotification('success', 'Gateway elements enabled.');
    }
  }

  render()
  {
    if (!this.props.activeTab) return false;

    return (
      <div>
        <AssociateGateway modalIsOpen={this.state.gatewayModalIsOpen} closeModal={this.closeGatewayModal} />
        <FormGroup row>
          <Label sm={2} for='defaultTimezone'>Default Timezone</Label>
          <Col sm={2}>
            <Select id='defaultTimezone' value={this.state.defaultTimezone} options={this.state.timezones} 
              getOptionLabel={option => option.timezone} getOptionValue={option => option.timezone}
              onChange={this.selectTZone} isClearable={false} autoFocus />
          </Col>
        </FormGroup>
        <FormGroup row title="If checked, new objects will be flagged as immutable (data) upon creation.">
          <Label sm="2" for="immutableOnCreate">Object immutable upon creation? </Label>
          <Col sm="1">
            <Input type="checkbox" id="immutableOnCreate" onChange={this.toggleImmutableOnCreate} 
              checked={'Y' === this.state.immutableUponCreation ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
          </Col>
        </FormGroup>
        <FormGroup row title='Automatically fetch Vault View data. Uncheck for big data sets.'>
          <Label sm="2" for='autoQueryEnabled' >Auto-fetch?</Label>
          <Col sm="1" >
            <Input type="checkbox" id="autoQueryEnabled" onChange={this.toggleAutoQuery.bind(this, 'autoQueryEnabled')} 
              checked={'Y' === this.state.autoQueryEnabled ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
          </Col>
        </FormGroup>          
        <FormGroup row title='The maximum number of rows to be fetched.'>
          <Label for='rowLimit' sm="2" >Row Limit</Label>
          <Col sm="1" >
            <InputNumber id='rowLimit' min={1} max={9999} value={this.state.rowLimit} 
              onChange={this.setRowLimit} />
          </Col>
        </FormGroup>
        <FormGroup row title='Automatically play media upon pressing the View/Play button.'>
          <Label sm="2" for='autoPlay' >Auto-Play Media?</Label>
          <Col sm="1" >
            <Input type="checkbox" id="autoPlay" onChange={this.toggleAutoPlay} 
              checked={'Y' === this.state.autoPlay ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
          </Col>
        </FormGroup>          
        <FormGroup row>
          <Label sm="2" for="gatewayElementsEnabled">Enable gateway elements? </Label>
          <Col sm="1">
            <Input type="checkbox" id="gatewayElementsEnabled" onChange={this.toggleGatewayEnabled} 
              checked={'Y' === this.state.gatewayElementsEnabled ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
          </Col>
        </FormGroup>
        <FormGroup row title='The number of files to upload simultaneously.'>
          <Label for='concurrentFileUploads' sm="2" >Concurrent File Uploads</Label>
          <Col sm="1" >
            <InputNumber id='concurrentFileUploads' min={1} max={20} value={this.state.concurrentFileUploads} 
              onChange={this.concurrentFileUploadsChanged} />
          </Col>
        </FormGroup>
      { 'Y' === this.context.websiteProfile.smtpEnabled &&
        <FormGroup row >
          <Col sm='2'>Authentication Method</Col>
          <Col>
            <Label check >
                <Input type="radio" name="authenticationMethod" checked={( 'password' === this.state.authMethod ? 'checked' : '')} 
                  onChange={() => this.authMethodChanged('password')} />
              &nbsp;Password&nbsp;
            </Label>
            <Label check title='Send an authorization code by email.'>
                <Input type="radio" name="authMethod" checked={( 'auth code' === this.state.authMethod ? 'checked' : '')} 
                  onChange={() => this.authMethodChanged('auth code')} />
              &nbsp;Auth Code&nbsp;
            </Label>
            <Label check title='Send a unique login URL by email.'>
                <Input type="radio" name="authMethod" checked={( 'login url' === this.state.authMethod ? 'checked' : '')} 
                  onChange={() => this.authMethodChanged('login url')} />
              &nbsp;Login URL&nbsp;
            </Label>
          </Col>
        </FormGroup>
    }
        <div>
          <Col sm="2">
            <Button id="updateUserInfoButton" onClick={this.updateUserPreferences} color="primary">Update</Button>
          </Col>
        </div>                      
      </div>
    );
  }

  selectTZone(selectedTZone, actionMetaD)
  {
    if (null === selectedTZone) return;
    this.setState({defaultTimezone: selectedTZone}, this.updateIcamUserPreferences);
  }

  setRowLimit(valueAsNumber)
  {
    this.setState({rowLimit: valueAsNumber});
  }

  toggleAutoQuery(field)
  {
    let autoQueryEnabled = this.state.autoQueryEnabled === 'N' ? 'Y' : 'N';

    this.setState({autoQueryEnabled: autoQueryEnabled});
  }

  toggleAutoPlay()
  {
    let autoPlay = this.state.autoPlay === 'N' ? 'Y' : 'N';
    this.setState({autoPlay});
    this.context.appLocalStorage.setAutoPlay(autoPlay);
  }

  toggleGatewayEnabled(event)
  {
    let gatewayElementsEnabled = this.state.gatewayElementsEnabled;
    if ('Y' === gatewayElementsEnabled)
    {
      this.setState({gatewayElementsEnabled: 'N'});      
      this.context.appLocalStorage.setGatewayName('');
    }
      
    else
      this.findDbObscuraGateway();
  }

  toggleImmutableOnCreate(event)
  {
    let immutableUponCreation = this.state.immutableUponCreation === 'N' ? 'Y' : 'N';
    this.setState({immutableUponCreation: immutableUponCreation});
  }

  async updateIcamUserPreferences()
  {
    let bodyData = {};
    bodyData.defaultTimezone = this.state.defaultTimezone.timezone;
    bodyData.authMethod = this.state.authMethod;

    let result = await this.context.dbTwig.callRestAPI('icam', 'updateUserPreferences', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating user ICAm preferences');
    this.context.postNotification('info', 'Your preferences have been updated.');
    this.context.userUiProfile.defaultTimezone = this.state.defaultTimezone.timezone;
    this.context.userUiProfile.authMethod = this.state.authMethod;
  }

  async updateUserPreferences()
  {
    let bodyData = {};
    bodyData.autoQueryEnabled = this.state.autoQueryEnabled;
    bodyData.concurrentFileUploads = this.state.concurrentFileUploads;
    bodyData.immutableUponCreation = this.state.immutableUponCreation;
    bodyData.rowLimit = this.state.rowLimit;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateUserPreferences', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating user preferences');
    this.context.postNotification('info', 'Your preferences have been updated.');
    this.context.userUiProfile.autoQueryEnabled = this.state.autoQueryEnabled
    this.context.userUiProfile.defaultTimezone = this.state.defaultTimezone.timezone;
    this.context.userUiProfile.concurrentFileUploads = this.state.concurrentFileUploads;
    this.context.userUiProfile.rowLimit = this.state.rowLimit;
  }
}

UserPreferences.contextType = AppContext;

export default UserPreferences